var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyCashGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V12C18 13.1046 17.1046 14 16 14H4C2.89543 14 2 13.1046 2 12V6ZM3.165 6C3.165 5.53884 3.53884 5.165 4 5.165H5C5.46116 5.165 5.835 5.53884 5.835 6C5.835 6.46116 5.46116 6.835 5 6.835H4C3.53884 6.835 3.165 6.46116 3.165 6ZM4 11.165C3.53884 11.165 3.165 11.5388 3.165 12C3.165 12.4612 3.53884 12.835 4 12.835H5C5.46116 12.835 5.835 12.4612 5.835 12C5.835 11.5388 5.46116 11.165 5 11.165H4ZM14.165 6C14.165 5.53884 14.5388 5.165 15 5.165H16C16.4612 5.165 16.835 5.53884 16.835 6C16.835 6.46116 16.4612 6.835 16 6.835H15C14.5388 6.835 14.165 6.46116 14.165 6ZM15 11.165C14.5388 11.165 14.165 11.5388 14.165 12C14.165 12.4612 14.5388 12.835 15 12.835H16C16.4612 12.835 16.835 12.4612 16.835 12C16.835 11.5388 16.4612 11.165 16 11.165H15ZM12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9ZM3 16C2.44772 16 2 15.5523 2 15H18C18 15.5523 17.5523 16 17 16H3Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCashGrey);
export default __webpack_public_path__ + "static/media/money-cash-grey.f6fabfc000b49992d49f52f707df4edb.svg";
export { ForwardRef as ReactComponent };